import React,{useState,useEffect} from "react";
import { Modal,Form, Input, Button, Upload, message } from "antd";
import paypal from "../../../assets/images/paypal.svg";
import stripe from "../../../assets/images/stripe.svg";
import square from "../../../assets/images/square.svg";
import { useSelector } from 'react-redux'



const { TextArea } = Input;

export default function PaymentSelectModal(props) {
  
 

  const adminRestaurant = useSelector((state) => state.admin)

  

 


    return (
        <Modal width={695} title={<div className="payment-select-titile">
            <div>Select Payment Provider</div>
            <div>amount $900</div>
        </div>} visible={props.modalOpen} footer={null} onCancel={()=>props.closeModal(false)}>
            <div className="payment-selectors">
                <div className="payment-img">
                <img src={paypal}/>
                </div>
                <div className="payment-img">
                <img src={stripe}/>
                </div>
                <div className="payment-img">
                <img src={square}/>
                </div>
            </div>
<div className="paymment-btn">
<Button type="primary"
							>Complete Payment</Button>
</div>
           
     
      </Modal>
    );
  }





